import React from 'react';
import { useStore } from '../context/StoreContext';
import SafeIcon from '../common/SafeIcon';

const BackupVault = () => {
  const { backups, createBackup, restoreBackup, deleteBackup } = useStore();

  return (
    <div className="max-w-4xl mx-auto py-2 sm:py-6 min-w-0">
      <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4 mb-6 sm:mb-8">
        <div>
          <h1 className="text-2xl sm:text-3xl font-bold text-gray-900">Backup Vault</h1>
          <p className="text-gray-500">Local snapshots of your entire workspace.</p>
        </div>
        <button 
          onClick={createBackup}
          className="w-full sm:w-auto min-h-12 flex items-center justify-center gap-2 px-4 py-3 bg-blue-600 text-white rounded-xl font-bold hover:bg-blue-700 transition shadow-lg shadow-blue-200"
        >
          <SafeIcon name="Plus" /> Create Backup Now
        </button>
      </div>

      {backups.length === 0 ? (
        <div className="bg-white rounded-2xl border border-dashed border-gray-300 p-8 sm:p-12 text-center text-gray-400">
          <SafeIcon name="Database" className="text-4xl mx-auto mb-4 opacity-20" />
          <p>No backups found. They are created automatically every 24 hours.</p>
        </div>
      ) : (
        <div className="space-y-4">
          {backups.map(backup => (
            <div key={backup.id} className="bg-white p-4 sm:p-6 rounded-2xl border border-gray-200 shadow-sm flex flex-col sm:flex-row sm:items-center justify-between gap-4 hover:border-blue-200 transition">
              <div className="flex items-center gap-4 min-w-0">
                <div className="w-12 h-12 bg-blue-50 rounded-xl flex items-center justify-center text-blue-600">
                  <SafeIcon name="Database" />
                </div>
                <div>
                  <div className="font-bold text-gray-900">{new Date(backup.createdAt).toLocaleString()}</div>
                  <div className="text-xs text-gray-500 flex gap-3 mt-1">
                    <span>{backup.data.notes.length} notes</span>
                    <span>{backup.data.workspaces.length} workspaces</span>
                  </div>
                </div>
              </div>
              
              <div className="flex items-center gap-2 w-full sm:w-auto justify-end">
                <button 
                  onClick={() => restoreBackup(backup)}
                  className="min-h-11 px-4 py-2 text-sm font-bold text-blue-600 hover:bg-blue-50 rounded-xl transition"
                >
                  Restore
                </button>
                <button 
                  onClick={() => deleteBackup(backup.id)}
                  className="min-w-11 min-h-11 p-2 text-gray-400 hover:text-red-500 hover:bg-red-50 rounded-xl transition"
                >
                  <SafeIcon name="Trash2" />
                </button>
              </div>
            </div>
          ))}
        </div>
      )}

      <div className="mt-8 sm:mt-12 p-4 sm:p-6 bg-blue-50 rounded-2xl border border-blue-100 flex gap-3 sm:gap-4">
        <SafeIcon name="Info" className="text-blue-500 shrink-0 mt-1" />
        <div className="text-sm text-blue-800 leading-relaxed">
          <strong>How backups work:</strong> Snapshots are stored entirely in your browser's IndexedDB. 
          They are not uploaded to any server. We recommend exporting a JSON backup occasionally to 
          move your data to another device or browser.
        </div>
      </div>
    </div>
  );
};

export default BackupVault;